<template>
  <div class="col-md-12 pt-0 pb-0">Deseja realmente excluir?</div>
</template>

<script>
import api from "../../../../services/api";

export default {
  name: "VerifyReleases",

  props: {
    type: String,
    id: [Number, String],
  },

  data() {
    return {
      total: 0,
    };
  },

  created() {
    this.countReleases();
  },

  methods: {
    async countReleases() {
      try {
        let { type, id } = this;

        const TYPE_CATEGORY = "finance_configuration_category";
        const TYPE_PROFIT_COST_CENTER =
          "finance_configuration_profit_cost_center";
        const TYPE_PAYMENT_METHODS = "finance_configuration_payment_methods";
        const TYPE_TAGS = "finance_configuration_tag";
        const TYPE_DOCUMENT_TYPES = "finance_configuration_document_types";
        const TYPE_CLIENT = "finance_client";
        const TYPE_PROVIDER = "provider";

        let types = [
          TYPE_CATEGORY,
          TYPE_PROFIT_COST_CENTER,
          TYPE_PAYMENT_METHODS,
          TYPE_TAGS,
          TYPE_DOCUMENT_TYPES,
          TYPE_CLIENT,
          TYPE_PROVIDER,
        ];

        if (!types.includes(type)) {
          return;
        }

        let params = { type, id };

        const response = await api.get("/rest-home/financial/count-releases", {
          params,
        });

        const { total } = response.data;

        this.total = total;

        this.$emit("total", total);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
